import React, { useState } from 'react';
import { HStack, Link, Spinner, Text, useDisclosure } from '@chakra-ui/react';
import { useHistory } from 'react-router';
import { PrivacyPolicyDialog } from '~/pages/Portal/Admin/PrivacyPolicy/PrivacyPolicyDialog';
import { getActualPrivacyPolicy } from '~/services/PrivacyPolicy';
import { PrivacyPolicyView } from '~/types/privacyPolicy';
import { Footer } from '~/components/Footer';
import { PRIVACY_POLICY_URL } from '~/constants';

export interface PrivacyPolicyFooterProps {
  isPortal?: boolean;
  bg?: string;
  justify?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
}

export const PrivacyPolicyFooter: React.FC<PrivacyPolicyFooterProps> = ({
  isPortal = true,
  bg = 'white',
  justify = 'flex-end',
}) => {
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState<PrivacyPolicyView | undefined>(undefined);
  const [isFetching, setIsFetching] = useState(false);
  const abrirModal = () => {
    setIsFetching(true);
    getActualPrivacyPolicy()
      .then(res => {
        if (!res || !res.id) return;
        setData(res);
        onOpen();
      })
      .finally(() => setIsFetching(false));
  };

  if (history.location.pathname.includes('/privacy-policy')) {
    return null;
  }

  return (
    <Footer
      py={4}
      w="100%"
      justify={justify}
      px="8"
      gridGap="4"
      borderTop={isPortal ? '1px solid' : 'none'}
      bg={bg}
      borderColor="gray.300"
      mt={isPortal ? '0' : '32px'}
    >
      <HStack fontSize="14px" gridGap={1}>
        {isFetching && <Spinner size="sm" />}
        <Text>© Positivo Tecnologia · Todos os direitos reservados · </Text>
        <Text
          cursor="pointer"
          m="0px !important"
          color="#3b61f9"
          fontWeight="500"
          onClick={abrirModal}
        >
          Termos de uso ·{' '}
        </Text>
        <Link
          isExternal
          m="0px !important"
          fontWeight="500"
          _hover={{ textDecoration: 'none' }}
          textDecoration="none"
          color="#3b61f9"
          href={PRIVACY_POLICY_URL}
        >
          Política de privacidade
        </Link>
      </HStack>
      {!!data && !!data.id && (
        <PrivacyPolicyDialog
          politica={data}
          onCloseModal={onClose}
          isOpenModal={isOpen}
        />
      )}
    </Footer>
  );
};
